export const iconFontAwesomeScienceRadiation = (
	<i className="fa-solid fa-radiation"></i>
);
